<template>
  <Popup
    v-model="objGetCard.show"
    class="mycard"
    :close-on-click-overlay="false"
  >
    <button class="close" @click="close"></button>
    <aside></aside>
    <div class="mycard-content">
      <h2>哇哦！人品爆发，获得了</h2>
      <p>{{ objGetCard.text }}</p>
      <span>已发送到【我的】-【我的奖品】中</span>
      <div class="btn">
        <button @click="close">再摇一次</button>
        <button @click="goUser">去使用</button>
      </div>
    </div>
  </Popup>
</template>
<script>
import { Popup } from 'vant'
export default {
  components: {
    Popup
  },
  props: {
    objGetCard: {
      type: Object
    }
  },
  data () {
    return {}
  },
  methods: {
    goUser () {
      this.$emit('getCardClose')
      this.$router.push({ path: 'couponCenter', query: { name: 'couponCenter', title: '我的奖品' } })
    },
    close () {
      this.$emit('getCardClose')
    }
  }
}
</script>
<style lang='less' scoped>
.mycard {
  background: none;
  width: 6rem;
  .close {
    width: 0.47rem;
    height: 0.46rem;
    background: url(./img/close.png) no-repeat;
    background-size: 100% auto;
    position: absolute;
    top: 0;
    right: 0;
    display: block;
  }
  aside {
    position: absolute;
    left: 50%;
    margin-left: -1.66rem;
    width: 3.33rem;
    height: 1.66rem;
    background: url(./img/gift.png) center no-repeat;
    background-size: 100% auto;
  }
  .mycard-content {
    margin-top: 0.8rem;
    border-radius: 0.2rem;
    background: #fffcf9;
    padding-top: 1rem;
    padding-bottom: 0.38rem;
    h2 {
      text-align: center;
      font-size: @fz34;
      color: #ff5d32;
      margin-top: 0.4rem;
    }
    p {
      padding: 0.4rem 0.3rem;
      text-align: center;
      font-size: @fz32;
      color: #2d2d3e;
      line-height: 0.4rem;
    }
    span {
      font-size: @fz24;
      color: #808080;
      display: block;
      text-align: center;
    }
    .btn {
      margin: 0 0.28rem;
      height: 0.7rem;
      margin-top: 0.4rem;
      .flex-between;
      button {
        width: 2.64rem;
        line-height: 0.7rem;
        height: 0.7rem;
        border-radius: 0.35rem;
        text-align: center;
        display: block;
        font-size: @fz28;
        color: #fff;
        background: #3498db;
        &:first-child {
          background: #ff6633;
        }
      }
    }
  }
}
</style>
